import React from "react";
import AccountsBase from "@/pages/AccountsBase";
export default function AccountsReceivable() { return <AccountsBase kind="receivable" />; }
